import React from 'react';
import * as Backend from '../../backend.js';
import shared from "../../share/shared.js";
import { Link } from "react-router-dom";
import * as util from "../../other/util.js";

// The sign up page
export default class SignUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            outstanding_request: false,
            error: {},
            active: {},
            name: "",
            password: "",
            mail: "",
            faction: "",
            faction_description: "",
        };
    }

    render() {
        return (
            <div style={{ "margin": "auto", "width": "600px" }}>
                <p>
                    <b>Signing up ...</b>
                    <div className="warning-text">
                        {this.state.error.global}
                    </div>
                </p>
                <table>
                    <tbody>
                        <SingleLineField name="Name" id="name" value={this.state.name} placeholder="name" error={this.state.active.name ? this.state.error.name : null}
                            onChange={(id, value) => this.onChange(id, value)}
                            onBlur={(id) => this.onBlur(id)} />
                        <SingleLineField name="Password" id="password" value={this.state.password} placeholder="password" error={this.state.active.password ? this.state.error.password : null}
                            onChange={(id, value) => this.onChange(id, value)}
                            onBlur={(id) => this.onBlur(id)} />
                        <SingleLineField name="eMail" id="mail" value={this.state.mail} placeholder="email" error={this.state.active.mail ? this.state.error.mail : null}
                            onChange={(id, value) => this.onChange(id, value)}
                            onBlur={(id) => this.onBlur(id)} />
                        <SingleLineField name="Faction" id="faction" value={this.state.faction} placeholder="faction name" error={this.state.active.faction ? this.state.error.faction : null}
                            onChange={(id, value) => this.onChange(id, value)}
                            onBlur={(id) => this.onBlur(id)} />
                    </tbody>
                </table>

                <table>
                    <tbody>
                        <MultiLineField name="Faction Description" id="faction_description" value={this.state.faction_description} placeholder="background story" error={this.state.active.faction_description ? this.state.error.faction_description : null}
                            onChange={(id, value) => this.onChange(id, value)}
                            onBlur={(id) => this.onBlur(id)} />
                    </tbody>
                </table>

                <br />
                <div style={{ textAlign: "center" }}>
                    <Link className="cool-button" to={{ pathname: '/', force_update: true }}>back</Link>
                    <span style={{ "margin": "20px" }} />
                    <util.DopeButton label="Register" loading={this.state.outstanding_request} onClick={() => {
                        this.onSubmit()
                    }} />
                </div>
            </div>
        );
    }

    onChange(id, value) {
        let state = JSON.parse(JSON.stringify(this.state));
        state[id] = value;
        state.error = shared.getSignUpErrors(state.name, state.password, state.mail, state.faction, state.faction_description);
        this.setState(state);
    }

    onBlur(id) {
        let state = JSON.parse(JSON.stringify(this.state));
        state.active[id] = true;
        state.error = shared.getSignUpErrors(state.name, state.password, state.mail, state.faction, state.faction_description);
        this.setState(state);
    }

    onSubmit() {
        let state = JSON.parse(JSON.stringify(this.state));
        state.active["name"] = true;
        state.active["password"] = true;
        state.active["mail"] = true;
        state.active["faction"] = true;
        state.active["faction_description"] = true;
        state.error = shared.getSignUpErrors(state.name, state.password, state.mail, state.faction, state.faction_description);
        if (JSON.stringify(state.error) !== "{}") {
            this.setState(state);
            return;
        }

        state.outstanding_request = true;
        this.setState(state);

        Backend.trySignUp(
            this.state.name,
            shared.secureHash(this.state.password),
            this.state.mail,
            this.state.faction,
            this.state.faction_description,
            (res) => this.handleSignUpResponse(res));
    }

    handleSignUpResponse(res) {
        if (!res.success) {
            this.setState({ outstanding_request: false, error: res.details || {} });
            return;
        }

        this.props.onDidSignUp();
    }
}

class SingleLineField extends React.Component {
    render() {
        let name = this.props.name;
        let id = this.props.id;
        let value = this.props.value;
        let placeholder = this.props.placeholder;
        let error = this.props.error;
        let color = error ? "pink" : undefined;
        let type = id === "password" ? "password" : "text";

        return (
            <tr>
                <td style={{ minWidth: "100px" }}>
                    {name}
                </td>
                <td>
                    <input type={type}
                        style={{ backgroundColor: color }}
                        maxLength="128"
                        placeholder={placeholder}
                        value={value}
                        onChange={(event) => {
                            if (event.target.value.length <= 128) {
                                this.props.onChange(id, event.target.value);
                            }
                        }}
                        onBlur={(event) => {
                            this.props.onBlur(id);
                        }}
                    />
                </td>
                <td>
                    <div className="warning-text">
                        {error}
                    </div>
                </td>
            </tr>
        );
    }
}

class MultiLineField extends React.Component {
    render() {
        let name = this.props.name;
        let id = this.props.id;
        let value = this.props.value;
        let placeholder = this.props.placeholder;
        let on_change = this.props.onChange;
        let error = this.props.error;

        return (
            <tr>
                <td style={{ minWidth: "100px" }}>
                    {name}
                </td>
                <td>
                    <textarea maxLength="100000"
                        rows="15"
                        cols="70"
                        placeholder={placeholder}
                        value={value}
                        onChange={(event) => {
                            if (event.target.value.length <= 10000) {
                                on_change(id, event.target.value);
                            }
                        }} />
                </td>
                <td>
                    <div className="warning-text">
                        {error}
                    </div>
                </td>
            </tr>
        );
    }
}